import {token} from "@atlaskit/tokens";
import type {SVGProps} from "react";

export function ChevronFirst() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
        >
            <path
                d="M11.5834 12L7.58335 8L11.5834 4M4.91669 4V12"
                stroke="#18191B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function ChevronPrevious() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
        >
            <path
                d="M10.75 12L6.75 8L10.75 4"
                stroke="#18191B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function ChevronNext() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
        >
            <path
                d="M6.75 12L10.75 8L6.75 4"
                stroke="#18191B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function ChevronLast() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
        >
            <path
                d="M5.41666 12L9.41666 8L5.41666 4M12.0833 4V12"
                stroke="#18191B"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

const WHATSAPP_ICON_PATH =
    "M13.6422 2.32503C12.1455 0.826459 10.155 0.000760311 8.03411 0C3.66385 0 0.10711 3.55636 0.10559 7.92777C0.104829 9.32521 0.47016 10.6892 1.16394 11.8913L0.0390625 16L4.24207 14.8975C5.40001 15.5294 6.70395 15.862 8.0307 15.8624H8.03411C12.4036 15.8624 15.9608 12.3056 15.9623 7.93423C15.963 5.81564 15.1392 3.82399 13.6422 2.32541V2.32503ZM8.03411 14.5235H8.03146C6.84916 14.5231 5.68933 14.2053 4.67736 13.605L4.43671 13.4621L1.94251 14.1163L2.60816 11.6845L2.45153 11.4351C1.79196 10.3859 1.44336 9.17314 1.44412 7.92817C1.44564 4.295 4.40173 1.33891 8.03681 1.33891C9.7969 1.33967 11.4514 2.02585 12.6956 3.27162C13.9399 4.51702 14.6245 6.17299 14.6238 7.93348C14.6222 11.567 11.6662 14.5231 8.03411 14.5231V14.5235ZM11.6486 9.5883C11.4506 9.48909 10.4766 9.01006 10.2949 8.94394C10.1132 8.87777 9.9813 8.84473 9.84936 9.04315C9.71746 9.24161 9.33769 9.68791 9.22211 9.8198C9.10654 9.9521 8.99096 9.96846 8.79289 9.86921C8.59487 9.77 7.95657 9.56092 7.19969 8.88613C6.61084 8.36075 6.21316 7.71223 6.09763 7.51377C5.98205 7.31535 6.08546 7.20813 6.18427 7.10967C6.27322 7.02072 6.38234 6.87817 6.48155 6.76259C6.58081 6.64701 6.61349 6.56417 6.67962 6.43223C6.74579 6.29993 6.7127 6.1844 6.6633 6.08515C6.61385 5.98593 6.21776 5.01081 6.05238 4.61433C5.89155 4.2281 5.72812 4.28056 5.60684 4.2741C5.49126 4.26839 5.35936 4.26725 5.22707 4.26725C5.09477 4.26725 4.88034 4.31667 4.69864 4.51512C4.51694 4.71354 4.00523 5.19291 4.00523 6.16764C4.00523 7.14236 4.715 8.08479 4.81421 8.21709C4.91342 8.34938 6.21125 10.3501 8.19834 11.2085C8.67091 11.4127 9.04001 11.5347 9.32778 11.6259C9.80225 11.7769 10.2341 11.7556 10.5755 11.7046C10.956 11.6476 11.7475 11.2252 11.9125 10.7626C12.0775 10.2999 12.0775 9.90305 12.0281 9.82055C11.9786 9.73806 11.8463 9.68826 11.6483 9.58905L11.6486 9.5883Z";

export function WhatsappIcon({color, size = 16}: {color?: string; size?: number} = {}) {
    const fill = color ?? token("color.icon");

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
        >
            {/* Inset 16×16 artwork in 24×24 viewBox to match Atlaskit medium icon optical size. */}
            <g transform="translate(4 4)">
                <path fillRule="evenodd" clipRule="evenodd" d={WHATSAPP_ICON_PATH} fill={fill} />
            </g>
        </svg>
    );
}
export function ScheduleCallIcon({color, size = 24}: {color?: string; size?: number} = {}) {
    const iconColor = color ?? token("color.icon.subtle");

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 5.75C5 5.33579 5.33579 5 5.75 5H9.25C9.58486 5 9.87915 5.22198 9.97114 5.54396L10.7923 8.41787C10.9826 9.08393 10.7621 9.79955 10.2299 10.243L8.28978 11.8598C9.2648 13.4106 10.5894 14.7352 12.1402 15.7102L13.757 13.7701C14.2004 13.2379 14.9161 13.0174 15.5821 13.2077L18.456 14.0289C18.778 14.1209 19 14.4151 19 14.75V18.25C19 18.6642 18.6642 19 18.25 19C15.984 19 13.8281 18.3906 11.9413 17.3359C9.73808 16.1041 7.89588 14.2619 6.66414 12.0587C5.60937 10.1719 5 8.01604 5 5.75ZM13.4844 16.4402C14.7341 17.0181 16.0897 17.3794 17.5 17.4747V15.3157L15.17 14.65C15.0749 14.6228 14.9727 14.6543 14.9093 14.7304L13.4844 16.4402ZM7.5598 10.5156L9.26964 9.09069C9.34566 9.02733 9.37716 8.9251 9.34997 8.82995L8.68427 6.5H6.5253C6.62056 7.91026 6.98186 9.26586 7.5598 10.5156Z"
                fill={iconColor}
            />
            <path
                d="M18.8906 9.25C18.8906 7.79162 17.7084 6.60938 16.25 6.60938C14.7916 6.60938 13.6094 7.79162 13.6094 9.25C13.6094 10.7084 14.7916 11.8906 16.25 11.8906C17.7084 11.8906 18.8906 10.7084 18.8906 9.25ZM16.5547 7.32031V9.10321L17.4561 9.82446L17.0752 10.3005L16.0596 9.48804L15.9453 9.39639V7.32031H16.5547ZM19.5 9.25C19.5 11.0449 18.0449 12.5 16.25 12.5C14.4551 12.5 13 11.0449 13 9.25C13 7.45507 14.4551 6 16.25 6C18.0449 6 19.5 7.45507 19.5 9.25Z"
                fill={iconColor}
            />
        </svg>
    );
}

export function ModelVariantIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.3333 9.99996C11.4128 9.99996 10.6666 10.7462 10.6666 11.6666C10.6666 12.5871 11.4128 13.3333 12.3333 13.3333C13.2537 13.3333 13.9999 12.5871 13.9999 11.6666C13.9999 10.7462 13.2537 9.99996 12.3333 9.99996ZM9.33325 11.6666C9.33325 10.0098 10.6764 8.66663 12.3333 8.66663C13.9901 8.66663 15.3333 10.0098 15.3333 11.6666C15.3333 13.3235 13.9901 14.6666 12.3333 14.6666C10.6764 14.6666 9.33325 13.3235 9.33325 11.6666Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.66675 9.99996C2.74627 9.99996 2.00008 10.7462 2.00008 11.6666C2.00008 12.5871 2.74627 13.3333 3.66675 13.3333C4.58722 13.3333 5.33342 12.5871 5.33342 11.6666C5.33342 10.7462 4.58722 9.99996 3.66675 9.99996ZM0.666748 11.6666C0.666748 10.0098 2.00989 8.66663 3.66675 8.66663C5.3236 8.66663 6.66675 10.0098 6.66675 11.6666C6.66675 13.3235 5.3236 14.6666 3.66675 14.6666C2.00989 14.6666 0.666748 13.3235 0.666748 11.6666Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.66675 3.33333C8.66675 2.59695 9.2637 2 10.0001 2C10.7365 2 11.3334 2.59695 11.3334 3.33333C11.3334 4.06971 10.7365 4.66667 10.0001 4.66667C9.2637 4.66667 8.66675 4.06971 8.66675 3.33333Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.77914 4.6762C8.95974 4.70714 9.11965 4.81104 9.22129 4.9635L10.3567 6.66663H11.3333C11.7014 6.66663 11.9999 6.96511 11.9999 7.3333C11.9999 7.70149 11.7014 7.99996 11.3333 7.99996H9.99992C9.77702 7.99996 9.56886 7.88856 9.44522 7.7031L8.5028 6.28947L7.01486 7.40543L8.47133 8.86189C8.59635 8.98692 8.66659 9.15649 8.66659 9.3333V11.6666C8.66659 12.0348 8.36811 12.3333 7.99992 12.3333C7.63173 12.3333 7.33325 12.0348 7.33325 11.6666V9.60944L5.52852 7.8047C5.39186 7.66804 5.32123 7.47881 5.33493 7.28604C5.34863 7.09326 5.44531 6.91592 5.59992 6.79996L8.26659 4.79996C8.41317 4.69002 8.59854 4.64526 8.77914 4.6762Z"
                fill="currentColor"
            />
        </svg>
    );
}
